import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import {
  Card,
  Button,
  Tabs,
  Radio,
  Input,
  DatePicker,
  Upload,
  message,
  Select,
  Form,
  Row,
  Col,
  Modal,
  Spin,
  Tag,
  Space,
} from "antd";
import { ajaxApi, newAjaxApi } from "@/server/index";
import {
  getParmUrl,
  uploadErrHandle,
  isPdf,
  transferSelectKeysByObj,
  getUniqueId,
  tokenConfig,
  getCookie,
} from "@/public/utils";
import _, { get, set } from "lodash";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import "../common.less";
import common from "@/public/common";
import styles from "../../index.module.less";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import {
  getBrandDataApi,
  syncImgUpload,
  saveBrandInfoApi,
  getSomeDictionarys,
  queryBrandQuaAuthApi,
  saveBrandQuaAuthApi,
  supplierBrandQuery,
  supplierBrandDelete,
  supplierBrandBaseQueryListApi,
  supplierBrandBaseAddApi,
} from "./../../service";
import {
  getSavedBrandQua,
  brandInformationDataConversion,
  handleBrandQua,
} from "./utils";
import ImgPreView from "@/compenents/imgPreView";
import goodsRefisterLiscence from "@/static/img/goodsRefisterLiscence.png";

const colorstyle = {
  color: "red",
};
const colorstyle1 = {
  color: "#00CD66",
};
const plainOptions = [
  { label: "自有品牌", value: 1, explain: "您是品牌持有人" },
  { label: "代理品牌", value: 2, explain: "您是品牌的代理人" },
];
var apihost = common.scpUrl;

// 查询接口响应 -> 页面品牌数据模型
var transformQueryToBrandData = function (resData, existingBrand) {
  if (!resData) return null;
  var brandQua = resData.brand_qua || {};
  var brandAuth = resData.brand_auth;
  var brand = resData.brand || {};

  // 商标注册证文件
  var quaFilesStr = brandQua.qua_files || "";
  var quaFiles = quaFilesStr ? quaFilesStr.split(",").filter(Boolean) : [];
  var quaFileListNew = quaFiles.map(function (url, idx) {
    return {
      uid: String(idx),
      name: url,
      status: "done",
      url: url,
      response: { url: url },
    };
  });

  // 商标注册证 (sort=1)
  var tradeCert = {
    qua_name: "商标注册证",
    sort: 1,
    brand_type: brandQua.brand_type || "",
    brand_register: brandQua.brand_register || "",
    qua_code: brandQua.qua_number || "",
    begin_time: brandQua.begin_time || null,
    end_time: brandQua.end_time || null,
    files: quaFiles,
    fileListNew: quaFileListNew,
  };

  // 自有品牌需要填写商标注册证 + 品牌授权书（授权视客），代理品牌不需要填写
  var qualList = [tradeCert];

  // 品牌授权书（授权视客）(sort=3) - 如果有 brand_auth 数据则回填
  if (brandAuth) {
    var authFiles = brandAuth.auth_file_detail_list || [];
    // 后端返回的字段为全小写（fileaddress/filename/authcode），兼容大小写两种格式
    var authUrls = authFiles
      .map(function (f) {
        return f.fileAddress || f.fileaddress;
      })
      .filter(Boolean);
    var authFileListNew = authFiles.map(function (f, idx) {
      var fileUrl = f.fileAddress || f.fileaddress;
      var fileName = f.fileName || f.filename || fileUrl;
      return {
        uid: String(idx),
        name: fileName,
        status: "done",
        url: fileUrl,
        response: { url: fileUrl },
      };
    });
    qualList.push({
      qua_name: "品牌授权书（授权视客）",
      sort: 3,
      begin_time: brandAuth.valid_start_time || null,
      end_time: brandAuth.valid_end_time || null,
      files: authUrls,
      fileListNew: authFileListNew,
    });
  } else {
    qualList.push({
      qua_name: "品牌授权书（授权视客）",
      sort: 3,
      begin_time: null,
      end_time: null,
      files: [],
      fileListNew: [],
    });
  }

  // 合并已有品牌信息
  var result = Object.assign({}, existingBrand, {
    brand_name: brand.brand_name_cn || get(existingBrand, "brand_name") || "",
    brand_id: brand.id || get(existingBrand, "brand_id"),
    brand_idd: brand.id || get(existingBrand, "brand_idd") || getUniqueId(),
    brand_qualification_list: qualList,
    _brand_qua_id: brandQua.id || null,
    _brand_qua_code: brandQua.brand_qua_code || "",
    _brand_code: brand.brand_code || "",
    _brand_auth_id: brandAuth ? brandAuth.id : null,
    _brand_auth_code: brandAuth ? brandAuth.code : "",
  });

  return result;
};

// 页面品牌数据 -> 保存接口请求体
var transformBrandToSaveData = (brand) => {
  var qualList = get(brand, "brand_qualification_list") || [];
  var tradeCert = _.find(qualList, { sort: 1 }) || {};
  var authDoc = _.find(qualList, { sort: 3 });

  var quaFiles = (tradeCert.files || []).join(",");

  var result = {
    supplier_code: getCookie("supplier_code") || "",
    brand_name: brand.brand_name || "",
    brand_role: brand.brand_role == 1 ? "owner" : "agency",
  };

  // 只有自有品牌才传 brand_qua
  if (brand.brand_role == 1) {
    result.brand_qua = {
      id: brand._brand_qua_id || null,
      brand_qua_code: brand._brand_qua_code || "",
      brand_code: brand._brand_code || "",
      brand_name: brand.brand_name || "",
      qua_name: "商标注册证",
      brand_type: tradeCert.brand_type || "",
      brand_register: tradeCert.brand_register || "",
      qua_number: tradeCert.qua_code || "",
      begin_time: tradeCert.begin_time || null,
      end_time: tradeCert.end_time || null,
      qua_files: quaFiles,
      chinese_mainland_regist_flag: true,
      is_delete: false,
    };

    if (authDoc) {
      var authFileList = (authDoc.fileListNew || []).map(function (f) {
        return {
          authCode: f.authCode || brand._brand_auth_code || "",
          fileName: f.name || "",
          fileAddress: f.url || get(f, "response.url") || "",
        };
      });
      result.brand_auth = {
        id: brand._brand_auth_id || null,
        code: brand._brand_auth_code || "",
        valid_start_time: authDoc.begin_time || null,
        valid_end_time: authDoc.end_time || null,
        auth_file_detail_list: authFileList,
      };
    }
  }

  return result;
};

const BrandInformation = (props, ref) => {
  const { getCurrent } = props;
  const [form] = Form.useForm();
  // const disabledStatus = props.disabled||false;
  const disabledStatus = getParmUrl("stepaction") == "look";
  const [paramData, setparamData] = useState({
    sid: getParmUrl("sid") || "",
    supplier_name: "",
    brand_list: [],
  });
  const [allBrandList, setAllBrandList] = useState([]);
  const [brandList, setbrandList] = useState([]);
  const [brandSelect, setbrandSelect] = useState([]);

  const [previewVisible, setPreviewVisible] = useState(false);
  const [preViewImgList, setPreViewImgList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalParams, setModalParams] = useState({});
  const [modalForm] = Form.useForm();
  const [modalLoading, setmodalLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeBrandTab, setActiveBrandTab] = useState("0");
  //字典
  const [dictionary, setDictionary] = useState({});

  useEffect(async () => {
    setLoading(true);
    await getSomeDictionarys().then((res) => {
      setDictionary(transferSelectKeysByObj(get(res, "data.data")));
    });
    if(!["null", null, undefined].includes(getCookie("supplier_code"))){
    await getSupplierBrand();
    }
    await getAllbrands();
    setLoading(false);
  }, []);

  //获取所有品牌（用于下拉选择）
  const getAllbrands = async () => {
    try {
      const res = await supplierBrandBaseQueryListApi({
        brand_name: "",
      });
      if (res.data.code == "0" && get(res, "data.data.brand_list")) {
        var brandList = res.data.data.brand_list || [];
        if (brandList.length !== 0) {
          brandList.forEach((item) => {
            item.label = item.brand_name_cn;
            item.value = `${item.id}/${item.brand_name_cn}`;
            // 同时设置 brand_name 字段，保持与内部数据结构一致
            item.brand_name = item.brand_name_cn;
            item.brand_id = item.id;
          });
          setAllBrandList(brandList);
        } else {
          setAllBrandList([]);
        }
      } else {
        setAllBrandList([]);
      }
    } catch (err) {
      setAllBrandList([]);
    }
  };

  // 搜索获取品牌字典（调用新接口）
  const getBrandsData = async (value) => {
    try {
      const res = await supplierBrandBaseQueryListApi({
        brand_name: value || "",
      });
      if (res.data.code == "0" && get(res, "data.data.brand_list")) {
        var brandList = res.data.data.brand_list || [];
        brandList.forEach((item) => {
          item.label = item.brand_name_cn;
          item.value = `${item.id}/${item.brand_name_cn}`;
          // 同时设置 brand_name 字段，保持与内部数据结构一致
          item.brand_name = item.brand_name_cn;
          item.brand_id = item.id;
        });
        setbrandList(brandList);
      } else {
        setbrandList([]);
      }
    } catch (err) {
      setbrandList([]);
    }
  };

  // 同步品牌数据到表单
  const syncBrandToForm = (brand, index) => {
    if (!brand) return;
    var key = brand.brand_idd + brand.brand_name;
    var qualList = get(brand, "brand_qualification_list") || [];
    var brandValues = {};

    qualList.forEach(function (item) {
      var quaName = item.qua_name;
      var quaValues = {
        begin_time: item.begin_time ? moment(item.begin_time) : null,
        end_time: item.end_time ? moment(item.end_time) : null,
        files: item.fileListNew || [],
      };
      // 商标注册证特有字段
      if (item.sort === 1) {
        quaValues.brand_type = item.brand_type || undefined;
        quaValues.brand_register = item.brand_register || undefined;
        quaValues.qua_code = item.qua_code || undefined;
      }
      brandValues[quaName] = quaValues;
    });

    form.setFieldsValue({ [key]: brandValues });
  };

  // 查询单个品牌的资质详情
  const queryBrandData = async (brandName, existingBrand) => {
    try {
      var res = await queryBrandQuaAuthApi({
        brand_name: brandName,
        supplier_code: getCookie("supplier_code") || "",
      });
      if (res.data.code == "0" && get(res, "data.data")) {
        var brandData = transformQueryToBrandData(res.data.data, existingBrand);
        return brandData;
      }
    } catch (err) {
      console.log("queryBrandData error:", err);
    }
    return null;
  };
  // 查询供应商已选品牌列表
  const getSupplierBrand = async () => {
    try {
      const res = await supplierBrandQuery({
        now: moment(),
        supplier_code: getCookie("supplier_code") || "",
      });
      if (res.data.code == "0" && get(res, "data.data")) {
        var rawList = res.data.data || [];
        if (rawList.length === 0) return;
        // 构建 brand_list
        var mappedList = rawList.map(function (item) {
          return {
            brand_id: item.brand_id,
            brand_idd: item.brand_id || getUniqueId(),
            brand_code: item.brand_code || "",
            brand_name: item.brand_name || "",
            brand_role: item.brand_role === "owner" ? 1 : 2,
            brand_qualification_list: [],
          };
        });
        mappedList = handleBrandQua(mappedList);
        // 构建下拉选项
        var options = mappedList.map(function (item) {
          return {
            label: item.brand_name,
            value: `${item.brand_id}/${item.brand_name}`,
          };
        });
        var selectValues = options.map(function (o) { return o.value; });
        setbrandList(options);
        setbrandSelect(selectValues);

        // 查询所有品牌的资质详情，以便正确显示填写状态
        for (var i = 0; i < mappedList.length; i++) {
          var brandData = await queryBrandData(mappedList[i].brand_name, mappedList[i]);
          if (brandData) {
            mappedList[i] = handleBrandQua([brandData])[0];
          }
        }

        var cloneData = brandInformationDataConversion({
          ...paramData,
          brand_list: mappedList,
        });
        setparamData(cloneData);
        form.setFieldsValue({ brandSelect: selectValues });

        // 同步第一个品牌的表单值
        if (mappedList.length > 0) {
          syncBrandToForm(mappedList[0], 0);
        }
      }
    } catch (err) {
      console.log("getSupplierBrand error:", err);
    }
  };

  // 删除品牌
  const handleDeleteBrand = (index, e) => {
    e.stopPropagation();
    var brandList = get(paramData, "brand_list") || [];
    var brand = brandList[index];
    if (!brand) return;
    Modal.confirm({
      title: "确认删除",
      content: `确定要删除品牌"${brand.brand_name}"吗？删除后该品牌的资质信息将一并清除。`,
      okText: "确定",
      cancelText: "取消",
      onOk: async () => {
        // 本地移除品牌列表中的该项
        var removeLocal = () => {
          var newList = brandList.filter(function (_, i) { return i !== index; });
          var newSelect = newList.map(function (b) { return `${b.brand_id}/${b.brand_name}`; });
          setbrandSelect(newSelect);
          setbrandList(newList.map(function (b) { return { label: b.brand_name, value: `${b.brand_id}/${b.brand_name}` }; }));
          setparamData(brandInformationDataConversion({ ...paramData, brand_list: newList }));
          form.setFieldsValue({ brandSelect: newSelect });
          // 调整 activeBrandTab
          if (Number(activeBrandTab) >= newList.length) {
            setActiveBrandTab(String(Math.max(0, newList.length - 1)));
          }
        };
        // 没有 brand_id 说明品牌还未保存到后端（下拉新选/弹窗新建），直接本地移除
        if (!get(brand, "brand_id")) {
          message.success("删除成功");
          removeLocal();
          return;
        }
        try {
          var res = await supplierBrandDelete({
            brand_name: brand.brand_name,
            supplier_code: getCookie("supplier_code") || "",
          });
          if (res.data.code == "0") {
            message.success("删除成功");
            removeLocal();
          } else {
            // 后端删除失败也移除本地（兼容后端本无此条数据的情况），但不提示成功
            removeLocal();
          }
        } catch (err) {
          console.log("delete error:", err);
          removeLocal();
        }
      },
    });
  };
  
  const handleBrandList = (res) => {
    //处理sort,fileNew(上传文件回显)
    const sortObj = {
      商标注册证: 1,
      品牌被授权书: 2,
      "品牌授权书（授权视客）": 3,
    };
    try {
      var brand_list = get(res, "data.data.brand_list").map((brand) => {
        return {
          ...brand,
          brand_qualification_list: get(
            brand,
            "brand_qualification_list",
            [],
          ).map((item) => {
            return {
              ...item,
              sort: sortObj[get(item, "qua_name")],
              fileListNew: get(item, "files").map((url, index) => {
                return {
                  url,
                  uid: index.toString(),
                  name: url,
                  status: "done",
                  response: { url },
                };
              }),
            };
          }),
        };
      });
    } catch (err) {
      console.log(err);
    }
    return brand_list;
  };

  const handleSelect = (val) => {
    setbrandSelect(val);
    var oldList = get(paramData, "brand_list") || [];
    var newBrandList = getSavedBrandQua(val, paramData);
    setparamData(
      brandInformationDataConversion({
        ...paramData,
        brand_list: newBrandList,
      }),
    );
    // 确保 activeTab 有效
    if (Number(activeBrandTab) >= newBrandList.length) {
      setActiveBrandTab(String(Math.max(0, newBrandList.length - 1)));
    }
    // 找到新增的品牌，触发查询
    var oldNames = oldList.map(function (b) {
      return b.brand_name;
    });
    var added = _.filter(newBrandList, function (b) {
      return !oldNames.includes(b.brand_name);
    });
    if (added.length > 0) {
      var newIdx = _.findIndex(newBrandList, {
        brand_name: added[0].brand_name,
      });
      if (newIdx >= 0) {
        setActiveBrandTab(String(newIdx));
        queryBrandData(added[0].brand_name, newBrandList[newIdx]).then(
          function (data) {
            if (data) {
              var updatedBrand = handleBrandQua([data])[0];
              setparamData(function (prev) {
                var list = (prev.brand_list || []).slice();
                if (list[newIdx]) {
                  list[newIdx] = updatedBrand;
                }
                return brandInformationDataConversion({
                  ...prev,
                  brand_list: list,
                });
              });
              // 同步表单值
              syncBrandToForm(updatedBrand, newIdx);
            }
          },
        );
      }
    }
  };

  // 切换 tab 时触发查询
  const handleBrandTabChange = (key) => {
    setActiveBrandTab(key);
    var idx = Number(key);
    var brand = get(paramData, "brand_list") || [];
    if (brand[idx] && brand[idx].brand_name) {
      var brandName = brand[idx].brand_name;
      var existing = brand[idx];
      queryBrandData(brandName, existing).then(function (data) {
        if (data) {
          var updatedBrand = handleBrandQua([data])[0];
          setparamData(function (prev) {
            var list = (prev.brand_list || []).slice();
            list[idx] = updatedBrand;
            return brandInformationDataConversion({
              ...prev,
              brand_list: list,
            });
          });
          // 同步表单值
          syncBrandToForm(updatedBrand, idx);
        }
      });
    }
  };

  // 获取时间
  const handleDate = (e, index, index2, name) => {
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    paramDataClone.brand_list[index].brand_qualification_list[index2][name] = e
      ? moment(e).valueOf()
      : null;
    if (name === "begin_time") {
      const beginTime = e ? moment(e).valueOf() : null;
      const endTime =
        paramDataClone.brand_list[index].brand_qualification_list[index2]
          .end_time;
      if (beginTime > endTime) {
        paramDataClone.brand_list[index].brand_qualification_list[
          index2
        ].end_time = null;
      }
    }
    setparamData(brandInformationDataConversion(paramDataClone));
  };

  // 品牌角色
  const handleRadio = (e, index) => {
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    paramDataClone.brand_list[index].brand_role = e.target.value;
    paramDataClone.brand_list = handleBrandQua(paramDataClone.brand_list);
    setparamData(brandInformationDataConversion(paramDataClone));
  };
  // 输入框的值
  const handleInput = (e, index, index2, name) => {
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    paramDataClone.brand_list[index].brand_qualification_list[index2][name] =
      e.target.value || "";
    setparamData(brandInformationDataConversion(paramDataClone));
  };

  // 禁止结束时间小于或者等于开始时间
  const disabledCreateDateTime = (current, index, index2) => {
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    const startTime =
      paramDataClone.brand_list[index].brand_qualification_list[index2]
        .begin_time;
    return current && current < moment(startTime);
  };

  // 上传
  const handleChangeFileAuthorize = (index, index2, { file, fileList }) => {
    //删除触发onchange事件就return出去
    if (file.status === "removed") {
      return;
    }
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    // let fileList = [...info.fileList]
    // 1. 限制上载的文件数
    // 只显示两个最近上传的文件，旧文件将被新文件替换
    // fileList = fileList.slice(-2)
    // 2. 从响应读取并显示文件链接
    if (file.status === "done") {
      fileList = fileList.map((item, index) => {
        // 相关文件对象数据格式化处理
        // if (item.name !== item.response.url) {
        //   // item.name = item.response.url
        // }
        var url = item.url || get(item, "response.url");
        return {
          uid: index.toString(),
          name: url,
          response: { url },
          status: "done",
          url: url,
        };
      });
    }

    paramDataClone.brand_list[index].brand_qualification_list[
      index2
    ].fileListNew = uploadErrHandle(file, fileList);
    paramDataClone.brand_list[index].brand_qualification_list[
      index2
    ].fileListNew.forEach((item) => {
      if (item.response && item.response.url) {
        paramDataClone.brand_list[index].brand_qualification_list[
          index2
        ].files.push(item.response.url);
        paramDataClone.brand_list[index].brand_qualification_list[
          index2
        ].files = _.uniqWith(
          paramDataClone.brand_list[index].brand_qualification_list[index2]
            .files,
          _.isEqual,
        );
      }
    });
    setparamData(brandInformationDataConversion(paramDataClone));
  };

  // 删除
  const handleDeleteFile = (index, index2, file) => {
    const paramDataClone = JSON.parse(JSON.stringify(paramData));
    const _url = file.response.url;
    var deleteItem =
      paramDataClone.brand_list[index].brand_qualification_list[index2];
    set(
      deleteItem,
      "files",
      _.filter(get(deleteItem, "files"), function (file) {
        return !file.includes(_url);
      }),
    );
    set(
      deleteItem,
      "fileListNew",
      _.filter(get(deleteItem, "fileListNew"), function (file) {
        return file.url !== _url;
      }),
    );
    setparamData(paramDataClone);
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e.fileList;
  };

  const onPreview = (file) => {
    var url = file.url || get(file, "response.url");
    if (!isPdf(url)) {
      setPreViewImgList([{ src: url }]);
      setPreviewVisible(true);
    } else {
      window.open(url);
    }
  };

  const getSelectBrandsHtml = () => {
    var brandList = get(paramData, "brand_list") || [];
    if (brandList.length === 0) return null;

    return (
      <Tabs
        activeKey={activeBrandTab}
        onChange={handleBrandTabChange}
        type="card"
        tabPosition="top"
      >
        {brandList.map((brand, index) => {
          var fillin = get(brand, "fillin");
          return (
            <Tabs.TabPane
              key={String(index)}
              tab={
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  {get(brand, "brand_name") || `品牌${index + 1}`}
                  <Tag
                    color={fillin ? "success" : "warning"}
                    style={{ marginLeft: 8 }}
                  >
                    {fillin ? "已填写" : "待填写"}
                  </Tag>
                  {!disabledStatus && (
                    <span
                      onClick={(e) => handleDeleteBrand(index, e)}
                      style={{ marginLeft: 6, color: "#999", fontSize: 12, cursor: "pointer", lineHeight: 1 }}
                      title="删除品牌"
                    >
                      ×
                    </span>
                  )}
                </span>
              }
            >
              <div style={{ padding: "8px 0" }}>
                <div
                  className="brandRole"
                  style={{
                    marginBottom: 8,
                    padding: "8px 12px",
                    background: "#fafafa",
                    borderRadius: 6,
                    border: "1px solid #e8e8e8",
                  }}
                >
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <span style={{ fontWeight: 500, marginRight: 12 }}>
                    品牌角色：
                  </span>
                  <Radio.Group
                    disabled={disabledStatus}
                    value={get(brand, "brand_role")}
                    onChange={(e) => handleRadio(e, index)}
                  >
                    {plainOptions.map((item) => {
                      return (
                        <Radio
                          key={get(item, "value")}
                          value={get(item, "value")}
                        >
                          {get(item, "label")}
                          <span style={{ color: "#999", marginLeft: 4 }}>
                            ({get(item, "explain")})
                          </span>
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </div>
                {get(brand, "brand_role") == 2 ? (
                  <div
                    style={{
                      padding: "24px 0",
                      textAlign: "center",
                      color: "#999",
                      background: "#fafafa",
                      borderRadius: 6,
                      border: "1px dashed #d9d9d9",
                    }}
                  >
                    代理品牌无需填写资质信息
                  </div>
                ) : (
                  get(brand, "brand_qualification_list").map((item, index2) => {
                    var required = true;
                    return (
                      <Card
                        style={{
                          marginBottom: 8,
                          borderRadius: 6,
                          boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                        }}
                        headStyle={{
                          background: "#fafafa",
                          borderBottom: "1px solid #e8e8e8",
                          minHeight: "auto",
                        }}
                        key={index2}
                        title={
                          <span>
                            <span
                              style={{
                                color: "#fa8c16",
                                fontWeight: 500,
                                fontSize: 16,
                              }}
                            >
                              {item.qua_name}
                            </span>
                            {item.sort == 1 && (
                              <a
                                href={goodsRefisterLiscence}
                                target="_blank"
                                style={{ marginLeft: 12, fontSize: 12 }}
                              >
                                填写示例
                              </a>
                            )}
                          </span>
                        }
                      >
                        <Row gutter={[12, 8]}>
                          <Col span={12}>
                            <Form.Item
                              label={
                                <span>
                                  {required && (
                                    <span className={styles.required}>*</span>
                                  )}
                                  有效时间
                                </span>
                              }
                              style={{ marginBottom: 8 }}
                            >
                              <Input.Group compact>
                                <Form.Item
                                  noStyle
                                  name={[
                                    brand.brand_idd + brand.brand_name,
                                    item.qua_name,
                                    "begin_time",
                                  ]}
                                  initialValue={
                                    item.begin_time
                                      ? moment(item.begin_time)
                                      : null
                                  }
                                  rules={[
                                    { required, message: "请选择有效开始时间" },
                                  ]}
                                >
                                  <DatePicker
                                    className={styles.datestyle}
                                    disabled={disabledStatus}
                                    onChange={(e) =>
                                      handleDate(e, index, index2, "begin_time")
                                    }
                                    placeholder="开始时间"
                                  />
                                </Form.Item>
                                <span
                                  style={{
                                    margin: "0px 8px",
                                    lineHeight: "32px",
                                    color: "#999",
                                  }}
                                >
                                  ~
                                </span>
                                <Form.Item
                                  noStyle
                                  name={[
                                    brand.brand_idd + brand.brand_name,
                                    item.qua_name,
                                    "end_time",
                                  ]}
                                  rules={[
                                    { required, message: "请选择有效结束时间" },
                                  ]}
                                  initialValue={
                                    item.end_time ? moment(item.end_time) : null
                                  }
                                >
                                  <DatePicker
                                    className={styles.datestyle}
                                    disabled={disabledStatus}
                                    disabledDate={(e) =>
                                      disabledCreateDateTime(e, index, index2)
                                    }
                                    onChange={(e) =>
                                      handleDate(e, index, index2, "end_time")
                                    }
                                    placeholder="结束时间"
                                  />
                                </Form.Item>
                              </Input.Group>
                            </Form.Item>
                          </Col>
                          {item.sort == 1 && (
                            <Col span={12}>
                              <Form.Item
                                {...brand}
                                initialValue={get(item, "brand_type")}
                                label="商标类别"
                                name={[
                                  brand.brand_idd + brand.brand_name,
                                  item.qua_name,
                                  "brand_type",
                                ]}
                                rules={[
                                  { required, message: "请选择商标类别" },
                                ]}
                                style={{ marginBottom: 8 }}
                              >
                                <Select
                                  allowClear
                                  className={styles.inputstyle}
                                  disabled={disabledStatus}
                                  placeholder="请选择"
                                  style={{ width: "300px" }}
                                  onChange={(e) =>
                                    handleInput(
                                      { target: { value: e } },
                                      index,
                                      index2,
                                      "brand_type",
                                    )
                                  }
                                  options={get(dictionary, "brand_type_dict")}
                                ></Select>
                              </Form.Item>
                            </Col>
                          )}
                          {item.sort == 1 && (
                            <Col span={12}>
                              <Form.Item
                                {...brand}
                                initialValue={get(item, "brand_register")}
                                label="商标注册人"
                                name={[
                                  brand.brand_idd + brand.brand_name,
                                  item.qua_name,
                                  "brand_register",
                                ]}
                                rules={[
                                  { required, message: "请输入商标注册人" },
                                ]}
                                style={{ marginBottom: 8 }}
                              >
                                <Input
                                  placeholder="请输入与商标注册证一致的名称"
                                  style={{ width: "305px" }}
                                  disabled={disabledStatus}
                                  onChange={(e) =>
                                    handleInput(
                                      e,
                                      index,
                                      index2,
                                      "brand_register",
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                          )}
                          {item.sort == 1 && (
                            <Col span={12}>
                              <Form.Item
                                {...brand}
                                initialValue={get(item, "qua_code")}
                                label="商标证号"
                                name={[
                                  brand.brand_idd + brand.brand_name,
                                  item.qua_name,
                                  "qua_code",
                                ]}
                                rules={[
                                  { required, message: "请填写商标证号" },
                                ]}
                                style={{ marginBottom: 8 }}
                              >
                                <Input
                                  style={{ width: "300px" }}
                                  placeholder="请输入"
                                  disabled={disabledStatus}
                                  onChange={(e) =>
                                    handleInput(e, index, index2, "qua_code")
                                  }
                                />
                              </Form.Item>
                            </Col>
                          )}
                          <Col span={24}>
                            <Form.Item
                              label="资质附件"
                              name={[
                                brand.brand_idd + brand.brand_name,
                                item.qua_name,
                                "files",
                              ]}
                              rules={[
                                {
                                  required,
                                  message: "请上传资质附件",
                                  validator: async (rule, value) => {
                                    if (
                                      required &&
                                      !get(item, "fileListNew.length")
                                    ) {
                                      throw new Error("Something wrong!");
                                    }
                                  },
                                },
                              ]}
                              getValueFromEvent={normFile}
                              style={{ marginBottom: 0 }}
                            >
                              <Upload
                                action={apihost + "supplier-enter/upload-file"}
                                headers={{ ...tokenConfig }}
                                showUploadList={{
                                  showRemoveIcon: !disabledStatus,
                                }}
                                onPreview={onPreview}
                                accept=".pdf,image/jpeg,image/jpg,image/png"
                                onChange={(e) =>
                                  handleChangeFileAuthorize(index, index2, e)
                                }
                                onRemove={(e) =>
                                  handleDeleteFile(index, index2, e)
                                }
                                onPreview={e=>{
                                  window.open(e.url)
                                }}
                                fileList={item.fileListNew || []}
                              >
                                <Button disabled={disabledStatus}>
                                  <UploadOutlined />
                                  上传文件
                                </Button>
                                <span
                                  style={{
                                    display: "inline-block",
                                    marginLeft: "8px",
                                    color: "#999",
                                    fontSize: 12,
                                  }}
                                >
                                  仅支持扩展名：.pdf、.jpg、.png
                                </span>
                              </Upload>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    );
                  })
                )}
              </div>
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    );
  };

  // 保存
  const handlePreservation = () => {
    return publicFunc("save");
  };

  // 提交
  const handleSubmitReview = () => {
    return new Promise((resolve, reject) => {
      try {
        var brandList = get(paramData, "brand_list") || [];
        if (!brandList.length) {
          message.error("请选择品牌");
          reject();
          return;
        }
        // 先校验表单必填项（antd Form 校验，能定位到具体字段）
        form
          .validateFields()
          .then(() => {
            // 表单校验通过后，调 publicFunc 循环保存所有品牌（内部还会校验 fillin）
            publicFunc("next").then(resolve).catch(reject);
          })
          .catch((err) => {
            if (_.get(err, "errorFields.length")) {
              var brand_name = _.get(
                _.filter(get(paramData, "brand_list"), function (brand) {
                  return (
                    brand.brand_idd + brand.brand_name ==
                    err.errorFields[0].name[0]
                  );
                }),
                "0.brand_name",
              );
              message.error("品牌名：" + brand_name + " 中有必填项信息未填写！");
              form.scrollToField(err.errorFields[0].name);
            }
            reject(err);
          });
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  };

  // 保存提交公共方法（循环遍历所有品牌逐个保存）
  const publicFunc = async (operate_type) => {
    try {
      var brandList = get(paramData, "brand_list") || [];
      if (!brandList.length) {
        message.error("请选择品牌");
        return Promise.reject();
      }
      // 先校验所有品牌的必填项是否填完
      var unfilledBrands = brandList.filter(function (brand) {
        return !get(brand, "fillin");
      });
      if (unfilledBrands.length > 0) {
        var unfilledNames = unfilledBrands.map(function (brand) {
          return get(brand, "brand_name") || "未知品牌";
        }).join("、");
        message.error("以下品牌信息未填写完整：" + unfilledNames + "，请补充后再保存！");
        // 切到第一个未填写的品牌 tab
        var firstUnfilledIndex = _.findIndex(brandList, function (brand) {
          return !get(brand, "fillin");
        });
        if (firstUnfilledIndex >= 0) {
          setActiveBrandTab(String(firstUnfilledIndex));
        }
        return Promise.reject();
      }
      // 全部填完，逐个保存
      setLoading(true);
      for (var i = 0; i < brandList.length; i++) {
        await publicFuncApi(brandList[i], operate_type, i);
      }
      setLoading(false);
      if (operate_type === "next") {
        message.success("品牌信息提交成功!");
        getCurrent(2);
      } else {
        message.success("品牌信息保存成功!");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      throw err;
    }
  };

  const publicFuncApi = async (brand, operate_type, index) => {
    try {
      var saveData = transformBrandToSaveData(brand);
      const res = await saveBrandQuaAuthApi(saveData);
      if (res.data.code == "0") {
        if (operate_type === "next") {
          // 提交：最后一个品牌保存完会统一提示并跳步，这里不单独提示
        } else {
          // 保存：重新查询当前品牌刷新表单
          var refreshed = await queryBrandData(brand.brand_name, brand);
          if (refreshed) {
            setparamData(function (prev) {
              var list = (prev.brand_list || []).slice();
              list[index] = handleBrandQua([refreshed])[0];
              return brandInformationDataConversion({
                ...prev,
                brand_list: list,
              });
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  // 暴露给父组件底部按钮调用，返回 Promise 以支持按钮 loading
  useImperativeHandle(ref, () => ({
    save: () => handlePreservation(),
    submit: () => handleSubmitReview(),
  }));

  const addBrandSubmit = async (open) => {
    try {
      const values = await modalForm.validateFields();
      var brand_logo = get(modalParams, "files.0.response.url");
      var brand_name = values.brand_name;
      // 调用新增品牌接口
      setmodalLoading(true);
      var addRes = await supplierBrandBaseAddApi({
        brand_name_cn: brand_name,
        brand_img: brand_logo,
      });
      setmodalLoading(false);
      if (addRes.data.code == "0") {
        message.success("添加成功，请在下拉框中搜索选择");
        handleCancalModal(!open);
      }
    } catch (err) {
      setmodalLoading(false);
      console.log(err);
    }
  };

  const beforeUpload = async (file) => {
    var size = 3;
    // 大小校验
    if (file.size > Number(size) * 1024 * 1024) {
      message.warning(
        `文件${file.name}大小超出规定 ${size}M ,请上传小于${size}M的图片`,
      );
      return Upload.LIST_IGNORE;
    }
    try {
      setmodalLoading(true);
      let res = await syncImgUpload(file);
      setmodalLoading(false);
    } catch (err) {
      console.log(err);
      setmodalLoading(false);
    }
  };

  const handleCancalModal = (close) => {
    modalForm.resetFields();
    setModalParams({});
    if (close) {
      setIsModalOpen(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <section className="brand_info">
        <Form className="twoRow" form={form} style={{}}>
          <div className="selectPart total_title" style={{ marginBottom: 16 }}>
            <div className={styles.sub_section}>
              <span className={styles.sub_section_title}>品牌信息</span>
            </div>
            <div
              style={{
                padding: "12px 16px",
                background: "#fafafa",
                borderRadius: 6,
                border: "1px solid #e8e8e8",
              }}
            >
              <Form.Item
                label={
                  <span>
                    <span className={styles.required}>*</span>选择品牌
                  </span>
                }
                style={{ marginBottom: 8 }}
              >
                <Form.Item name={"brandSelect"} style={{ marginBottom: 8 }}>
                  <Select
                    allowClear
                    showSearch
                    disabled={disabledStatus}
                    mode="multiple"
                    style={{ width: 400 }}
                    options={brandList}
                    placeholder="请输入品牌名称搜索"
                    onSearch={(e) => getBrandsData(e)}
                    onChange={handleSelect}
                  ></Select>
                </Form.Item>
                <p style={{ margin: 0, color: "#666" }}>
                  未查询到所有品牌？代表视客品牌库中不存在，请
                  <Button
                    type="link"
                    style={{ paddingLeft: 4, paddingRight: 0 }}
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                    disabled={disabledStatus}
                  >
                    点此新增品牌
                  </Button>
                </p>
              </Form.Item>
            </div>
          </div>
          <div className="selectPart total_title" style={{ marginBottom: 16 }}>
            <div className={styles.sub_section}>
              <span className={styles.sub_section_title}>品牌资质</span>
            </div>
            {get(paramData, "brand_list.length") === 0 ? (
              <div
                style={{
                  padding: "24px 0",
                  textAlign: "center",
                  color: "#999",
                  background: "#fafafa",
                  borderRadius: 6,
                  border: "1px dashed #d9d9d9",
                }}
              >
                请先选择品牌
              </div>
            ) : (
              getSelectBrandsHtml()
            )}
          </div>
        </Form>

        <Modal
          footer={[
            <Button
              onClick={() => {
                addBrandSubmit(0);
              }}
              disabled={modalLoading}
            >
              保存
            </Button>,
            <Button
              type="primary"
              onClick={() => {
                addBrandSubmit(1);
              }}
              disabled={modalLoading}
            >
              保存并添加下一个
            </Button>,
          ]}
          title="添加新品牌"
          open={isModalOpen}
          onOk={addBrandSubmit}
          onCancel={() => {
            handleCancalModal(true);
          }}
        >
          <Form form={modalForm} initialValues={{}} autoComplete="off">
            <Form.Item
              label="品牌名称"
              name={"brand_name"}
              rules={[{ required: true, message: "请输入品牌全称" }]}
            >
              <Input style={{ width: "300px" }} placeholder="请输入品牌全称" />
            </Form.Item>
            <Form.Item
              label="品牌logo"
              name={"files"}
              initialValue={[]}
              rules={[
                {
                  required: true,
                  message: "请上传品牌logo",
                  validator: async (rule, value) => {
                    if (!get(modalParams, "files.length")) {
                      throw new Error("Something wrong!");
                    }
                  },
                },
              ]}
              getValueFromEvent={normFile}
            >
              <Upload
                action={apihost + "supplier-enter/upload-file"}
                headers={{ ...tokenConfig }}
                listType="picture-card"
                onPreview={onPreview}
                maxCount={1}
                accept="image/jpeg,image/jpg,image/png"
                fileList={get(modalParams, "files")}
                onChange={(e) => {
                  setModalParams({ files: e.fileList });
                  modalForm.setFieldsValue({ files: e.fileList });
                }}
                onRemove={(e) => {
                  setModalParams({ files: [] });
                }}
                beforeUpload={beforeUpload}
              >
                {get(modalParams, "files.length") ? null : (
                  <div>
                    <PlusOutlined />
                    <p>上传</p>
                  </div>
                )}
              </Upload>
              <p
                style={{
                  color: "#cccccc",
                  fontSize: 13,
                }}
              >
                白色背景的正方形图片，尺寸大于等于200*200，大小不超过3M
              </p>
            </Form.Item>
          </Form>
        </Modal>
      </section>
    </Spin>
  );
};

export default forwardRef(BrandInformation);



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/brand/brand_info.js